
export const APILogon = async (username,password) => {

    try {
        const url ="https://portal.ttpadvisory.co.uk:3556/api/ttpuser/login";
        const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username,password})
        };
        const res = await fetch(url, requestOptions)
        //var ret
        if(res.status ===200) {
            const data = await res.json()
            console.log(data)
            //ret = data.data
            if(!data.auth) {
                return {status: false, err: "Invalid Logon Details"}
            }
            return {status: data.auth, data}
        }else {
            return {status: false, err: "Invalid Logon Details"}
        }
    }catch(err) {
        return {status: false, err: `Catch Error Logging on ${err}`} 
    }
}